import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import { AppContext } from 'store/AppContext';
import { getEmbaetti } from 'common/services/apiService';


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function EmbaettiFilter(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { setFilters, setEmbaettiFromFilter } = props;
  const [embaettiList, setEmbaettiList] = useState([]);
  const [embaettisnumer, setEmbaettisnumer] = useState('');

  useEffect(() => {
    async function fetchEmbaetti() {
      const { data, isSuccess, error } = await getEmbaetti(context, []);
      
      if (isSuccess) {
        setEmbaettiList(data);
      } else {
        console.error(error);
      }
    };

    fetchEmbaetti();
    setEmbaettiFromFilter && setEmbaettiFromFilter('Öll embætti'); // Default value
  }, [context, setEmbaettiFromFilter]);

  const handleEmbaettisnumerChange = event => {
    setEmbaettisnumer(event.target.value);

    const embaetti = embaettiList.find(e => e.embaettisnumer === event.target.value);
    if (embaetti !== undefined) {
      setEmbaettiFromFilter && setEmbaettiFromFilter(embaetti.nafn);
    } else {
      setEmbaettiFromFilter && setEmbaettiFromFilter('Öll embætti');
    }

    setFilters(state => ({
      ...state,
      embaettisnumer: event.target.value
    }));
  };

  const selectEmbaettiOfUser = () => {
    const userEmbaetti = context.user.get.details.embaettisnumer;
    setEmbaettisnumer(userEmbaetti);

    const embaetti = embaettiList.find(e => e.embaettisnumer === parseInt(userEmbaetti));
    if (embaetti !== undefined) {
      setEmbaettiFromFilter && setEmbaettiFromFilter(embaetti.nafn);
    } else {
      setEmbaettiFromFilter && setEmbaettiFromFilter('Öll embætti');
    }

    setFilters(state => ({
      ...state,
      embaettisnumer: userEmbaetti
    }));
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="filters-embaetti-select" shrink>
          Skráð af embætti
        </InputLabel>
        <Select
          labelId="filters-embaetti-select-label"
          id="filters-embaetti-select"
          value={embaettisnumer}
          displayEmpty={true}
          onChange={handleEmbaettisnumerChange}
        >
          <MenuItem value="">
            <em>Öll embætti</em>
          </MenuItem>
          {embaettiList.map((emb) => (
            <MenuItem key={emb.id} value={emb.embaettisnumer}>
              {emb.nafn}
            </MenuItem>
          ))}
        </Select>
        <Button size="small" color="primary" onClick={selectEmbaettiOfUser}>Velja mitt embætti</Button>
      </FormControl>
    </div>
  );
}